import styled from 'styled-components';

export const PhoneInputWrapper = styled.div`
  width: 380px;
  position: relative;

  .react-tel-input {
    font-family: 'Avenir-Medium', sans-serif;
  }

  .flag-dropdown {
    width: 5.2rem;
    &.open {
      width: 100%;
    }
  }

  .selected-flag {
    &.open {
      width: 100%;
    }
  }

  .country-list {
    background-color: white;
    color: #6a679e;
    border-bottom: 1px solid #e2dddb;
    width: 100%;
    border-radius: 8px;
    box-shadow: 0px 12px 24px -6px rgba(0, 0, 0, 0.460922);
  }

  .dial-code {
    font-weight: bold;
    color: #6a679e !important;
  }

  .country {
    &.highlight {
      background-color: #6a678e33 !important;
    }
  }

  .form-control {
    border-radius: 0px;
    border: none;
    border-bottom: 1px solid #e2dddb;
    padding: 10px;
    background: transparent;
    width: 100%;
    padding-left: 54px;
    color: #000;

    font-size: 16px;
    font-style: normal;
    font-family: 'Poppins-Medium';

    line-height: normal;
    letter-spacing: -0.2px;
    transition: 0.2s;
    &:active,
    &:hover,
    &:focus {
      border-bottom-color: #000;
      box-shadow: none;
    }
  }
  @media (max-width: 800px) {
    width: 100%;
  }
`;

export const Text = styled.span`
  left: 75%;
  top: 40%;
  //transform: translateY(-50%);
  position: absolute;
  font-size: 16px;
  font-style: normal;
  font-family: 'Poppins-Medium';
  opacity: 0.35;

  line-height: normal;
  letter-spacing: -0.2px;
  transition: 0.2s;
`;
